exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-select-trigger{font-size: 15px !important;}\n.mat-error{font-size: 12px;}\n.outer_width{width:700px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/supplier/profile/feature-form/feature-form.component.css
// module id = ../../../../../src/app/supplier/profile/feature-form/feature-form.component.css
// module chunks = 39